/* eslint-disable no-console */
import { datadogRum } from "@datadog/browser-rum"
import { useEffect } from "react"
import { AppViewer } from "./index"

// eslint-disable-next-line no-undef
export const useDatadogRum = ({ viewer }: { viewer?: AppViewer }): void => {
  useEffect(() => {
    const { href } = window.location

    if (!href.includes(`flockcover.com`)) return
    datadogRum.init({
      applicationId: `14688e62-75b9-422e-9095-87abee3bd62d`,
      clientToken: `pubc7dbff1a379a2baac5e84d3e37214734`,
      site: `datadoghq.eu`,
      service: `flock-portal`,
      env: href.includes(`staging`) ? `staging` : `prod`,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: `allow`,
      enableExperimentalFeatures: [`feature_flags`],
      allowedTracingUrls: [(url) => url.includes(`flockcover.com`)],
    })

    console.log(`starting datadog`)
    datadogRum.startSessionReplayRecording()
  }, [])

  useEffect(() => {
    if (!viewer) return
    datadogRum.setUser({ id: viewer.key, email: viewer.email, name: viewer.name, type: viewer.userType })
  }, [viewer])
}
